import { IHttpApi } from '@cian/http-api';
import { assertResponseError } from './assert';
import { IV2CreateConsultingResponse } from '../../repositories/newbuilding-flat-view-order/entities/consulting_request/V2CreateConsultingResponse';
import {
  fetchCreateConsultingRequest,
  TCreateConsultingRequestRequest,
  TCreateConsultingRequestResponse,
} from '../../repositories/newbuilding-flat-view-order/v2/create-consulting-request';

export const createConsultingRequest = async ({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: TCreateConsultingRequestRequest;
}): Promise<IV2CreateConsultingResponse> => {
  const result: TCreateConsultingRequestResponse = await fetchCreateConsultingRequest({ httpApi, parameters });

  assertResponseError(result);

  return result.response;
};
